<template>
  <ProductGallery v-if="0 !== products.length" :products="products" />
  <div v-else class="favorites__empty">
    <h4 class="favorites__empty-title">
      {{ _T("@You have no favorites") }} &#128546;
    </h4>
    <img
      :src="`/img/account-empty-favorites-${language.synonym}.svg`"
      alt="empty favorites"
      class="favorites__empty-img"
    />
    <ButtonLink name="catalog">
      {{ _T("@Go to catalog") }}
    </ButtonLink>
  </div>
</template>

<script setup>
import ProductGallery from "~/modules/productCatalog/ui/components/ProductGallery.vue";
import { useFavoriteProductStore } from "~/store/favoriteProductStore";
import ButtonLink from "~/modules/shared/buttons/ButtonLink.vue";
import { useLanguageStore } from "~/store/languageStore";

const languageStore = useLanguageStore();
const { getUserLanguage: language } = storeToRefs(languageStore);

const favoriteProductStore = useFavoriteProductStore();
const { getProducts: products } = storeToRefs(favoriteProductStore);
</script>

<style lang="scss" scoped>
.favorites {
  &__empty {
    width: 100%;

    @include flex-container(column, center, center);
    gap: 16px;
  }

  &__empty-title {
    @include font(24, 30);
    letter-spacing: 0.02em;
    text-align: center;

    @include mobile {
      @include font(18, 24);
    }
  }
}
</style>
